import axios from '../axios'

export const getProfile = (data) => {
  return axios({
      url: '/user/getProfile',
      method: 'get',
      data
  })
}
export const saveProfile = (data) => {
  return axios({
      url: '/user/saveProfile',
      method: 'post',
      data
  })
}

export const getShop = (data) => {
  return axios({
      url: '/user/getShop',
      method: 'get',
      data
  })
}
export const getOneNotice = (data) => {
  return axios({
      url: '/usernotice/get',
      method: 'get',
      params: {
        id: data
      },
      data
  })
}
export const getOneNoticeWithoutAuth = (data) => {
  return axios({
      url: '/usernotice/getOne',
      method: 'get',
      params: {
        id: data
      },
      data
  })
}
export const getNotices = (data) => {
  return axios({
      url: '/usernotice/findPage',
      method: 'post',
      data
  })
}
export const saveNotice = (data) => {
  return axios({
      url: '/usernotice/save',
      method: 'post',
      data
  })
}
export const delNotice = (data) => {
  return axios({
      url: '/usernotice/delete',
      method: 'get',
      params: {
        id: data
      },
  })
}
export const markAllNotice2Readed = (data) => {
  return axios({
      url: '/usernotice/mark2Readed',
      method: 'get',
      data
  })
}

export const getEmailVcode = (data) => {
  return axios({
      url: '/vcode/email',
      method: 'get',
      params: {
        email: data
      },
      data
  })
}
export const getPhoneVcode = (data) => {  
  return axios({
      url: '/vcode/phone',
      method: 'get',
      params: {
        phoneNo: data
      },
      data
  })
}
export const verifyVcode = (data) => {
  return axios({
      url: '/vcode/verify',
      method: 'get',
      params: {
        object: data.object,
        vcode: data.vcode,
        type:data.type
      },
      data
  })
}

export const checkPhone = (data) => {
  return axios({
      url: '/user/checkPhoneNo',
      method: 'get',
      params: {
        phoneNo: data
      },
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/user.js